import styled from "styled-components";

const SCTargetSkill = styled.div`
  padding: 0px 20px;
  background: rgba(0, 100, 169, 0.24);
  letter-spacing: 0.1em;
  border: 1px solid #53348b;
`;

export {
  SCTargetSkill
};
